<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m22.001 10.002v-4.00005c0-1.11-.9-2-2-2h-16.00002c-1.1 0-1.99.89-1.99 2v4.00005c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16.00002c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46005c-1.19.69-2 1.99005-2 3.46005s.81 2.77 2 3.46v2.54h-16.00002v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77005-1.99-3.46005l-.01-2.54h16.00002zm-9 6.46005h2v2h-2zm0-4h2v2h-2zm0-4.00005h2v2h-2z"
    />
  </svg>
</template>
